import service from "../services/dashboard.service";

import { GET_CLIENT_ADVISOR, GET_REPORT } from "./types";

export const getDashboard = () => async (dispatch) => {
  try {
    const response = await service.getDashboard();

    if (response.status === 200) {
      dispatch({
        type: GET_CLIENT_ADVISOR,
        payload: {
          talent: response.data.data.talent,
          company: response.data.data.company,
          algo: response.data.data.algo,
          opportunities: response.data.data.opportunities,
        },
      });
    }
  } catch (err) {
    console.error("Error in getting dashboard data:", err);
  }
};


export const getReport = (data) => async (dispatch) => {
  try {
    const response = await service.getReport();

    if (response.status === 200) {
      dispatch({
        type: GET_REPORT,
        payload: response.data,
      });
      return response.data;
    }
  } catch (err) {
    console.error("Error in getting report data:", err);
  }
};
